import { optionTitle_pbpMeetingTypesAndAvailability } from './ServiceListPbpOption.locstring.json';
import { optionTitle_pbp } from './strings.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import getShownView from 'owa-pbp-option/lib/selectors/getShownView';
import PersonalBookingPageShownView from './data/store/schema/PersonalBookingPageShownView';
import getAnonymousSharingStatus from 'owa-pbp-option-publishing-settings/lib/selectors/getAnonymousSharingStatus';

var lazyFullModule = new LazyModule(() => import('./lazyFullServiceListPbpOption'));
let ServiceListPbpOption: LazyOption = createLazyOption(
    {
        key: 'serviceListPbpOption',
        titleStringKey: optionTitle_pbpMeetingTypesAndAvailability,
        searchTermsStringKey: optionTitle_pbp,
        isHidden: () => {
            return (
                !isFeatureEnabled('cal-personalbookingpage') ||
                getShownView() != PersonalBookingPageShownView.Main ||
                !getAnonymousSharingStatus()
            );
        },
    },
    lazyFullModule,
    m => m.default
);
export default ServiceListPbpOption;
